import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'translateSizeClass'
})
export class TranslateSizeClassPipe implements PipeTransform {

  transform(value: string): any {
    return this.translateSizeClass(value);
  }

  translateSizeClass(cssClasses: string = ''): string {
    if ('' === cssClasses) {
      return cssClasses;
    }

    const replacementMap = {
      // BLOCK STYLES
      // Desktop
      'one-sixth-desktop': 'col-md-2',
      'one-third-desktop': 'col-md-4',
      'half-desktop': 'col-md-6',
      'two-thirds-desktop': 'col-md-8',
      'full-desktop': 'col-md-12',
      // Cross Promo only
      'vertical': 'vertical col-md-2',
      'square': 'square col-md-4',
      'rectangle': 'rectangle col-md-6',
      'narrow': 'narrow col-md-8',
      // Cross Promo and Dvic Offer only
      'banner': 'banner col-md-12',
      // Mobile
      'half-mobile-landscape': 'col-sm-6'
    };

    for (const i in replacementMap) {
      if (replacementMap.hasOwnProperty(i)) {
        cssClasses = cssClasses.replace(i, replacementMap[i]);
      }
    }

    return cssClasses;
  }

}
